<template>
  <div class="group">
    <div class="row">
      <div class="col-sm-2">
        <h3>{{ name ? name : trans('menu_planner_select.without_type') }}</h3>
      </div>
      <div class="btn-set pull-right">
        <button class="btn btn-danger" :disabled="!canEdit || isRemoving" @click="removeType()">
          {{ trans('menu_planner_select.remove_type') }}
        </button>
      </div>
    </div>
    <div class="table-responsive express-container">
      <table id="menu-planner-table" class="table table-bordered">
        <thead>
        <tr class="menu-header">
          <th>{{ trans('menu_planner.final_meal') }}</th>
          <th>{{ trans('menu_planner.final_meal_id') }}</th>
          <th>{{ trans('meal.entity.rate') }}</th>
          <th>{{ trans('badge.badge') }}</th>
          <th>{{ trans('meal.entity.tags') }}</th>
          <th>{{ trans('meal.entity.sizes') }}</th>
          <th>{{ trans('meal.entity.costs') }}</th>
          <th>{{ trans('meal.entity.prices') }}</th>
          <th>{{ trans('menu_planner_select.actions') }}</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(meal, index) in meals">
          <menu-planner-select-edit-meal
            :key="index"
            :available-meals="availableMeals"
            :brand="brand"
            :can-edit="canEdit"
            :date="date"
            :express-meal="meal"
            :express-variant-id="expressVariantId"
            :index="index"
            :type-id="typeId"
            @remove="remove(index)"
            @set="set"
          />
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import MenuPlannerSelectEditMeal from '@component/view/MenuPlannerSelectEditMeal.vue'
import toastr from '@js/toastr'
import bootbox from 'bootbox'

export default {
  components: { MenuPlannerSelectEditMeal },
  props: {
    date: {
      type: [String, Date],
      default: '',
    },
    brand: {
      type: [String, Number],
      default: '',
    },
    expressVariantId: {
      type: [String, Number],
      default: '',
    },
    plannedMeals: {
      type: Array,
      default: () => [],
    },
    availableMeals: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: '',
    },
    typeId: {
      type: [String, Number],
      default: '',
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      meals: [],
      isRemoving: false,
    }
  },
  mounted() {
    this.meals = this.plannedMeals
  },
  methods: {
    removeType() {
      bootbox.confirm({
        message: Translator.trans('menu_planner_select.remove_type_confirm'),
        buttons: {
          cancel: {
            label: `<i class="fa fa-times"></i> ${Translator.trans('note.back')}`
          },
          confirm: {
            label: `<i class="fa fa-check"></i> ${Translator.trans('note.remove')}`
          }
        },
        callback: async (result) => {
          if (result) {
            this.isRemoving = true

            await this.$http.post(
              // eslint-disable-next-line camelcase
              Routing.generate('api_remove_batch_meal_planner', { select_type_id: this.typeId }),
              this.meals.map(meal => meal.id)
            ).then(
              () => {
                this.isRemoving = false
                toastr.success(Translator.trans('form.removed'))
              }, response => {
                this.handleAjaxError(response)
                this.isRemoving = false
              })

            this.$emit('remove', this.typeId)
          }
        }
      })
    },
    remove(i) {
      this.meals.splice(i, 1)
    },
    set(i, meal) {
      this.meals[i] = meal
      this.$forceUpdate()
    },
  }
}
</script>

<style scoped>
h3 {
  margin: 0;
}

th:first-of-type {
  width: 750px;
}

th:not(:first-of-type) {
  width: 150px;
}

th:last-of-type {
  width: 100px;
}

.group {
  margin-bottom: 25px;
}

.pull-right {
  padding-right: 15px;
}

.menu-header {
  background: #3B3F51;
  color: #fff;
}

.express-container {
  padding-top: 10px;
  margin-bottom: 10px;
  overflow-x: unset;
}

#menu-planner-table td {
  vertical-align: middle;
}
</style>
